import SipHighlighting from './sip_highlighting';
export default SipHighlighting;
